import styled from "@emotion/styled";
import {
  createPolymorphicComponent,
  Text,
  type TextProps,
} from "@mantine/core";

const _ForgotPassword = styled(Text)`
  color: #a5d8ff;
  font-size: 0.8rem;
  margin-top: 10px;
  text-decoration: underline;
  text-align: end;
  padding: 0 5px;
  width: fit-content;
  cursor: pointer;
`;

const _ForgotPasswordWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

export const ForgotPassword = createPolymorphicComponent<"text", TextProps>(
  _ForgotPassword,
);
export const ForgotPasswordWrapper = createPolymorphicComponent<
  "text",
  TextProps
>(_ForgotPasswordWrapper);
